import React from 'react';
import { PageHeader, PrimaryActionButton } from '@/shared/components/patterns';

export function AssignmentsCreateButton({ onCreate }) {
  return (
    <PrimaryActionButton onClick={onCreate} aria-label="Nuovo task">
      Nuovo task
    </PrimaryActionButton>
  );
}

export default function AssignmentsHeader() {
  return (
    <PageHeader
      title="Tasks"
      description="Gestisci i task del team e monitora lo stato delle attività"
    />
  );
}
